import React from 'react'
import {GoSearch} from 'react-icons/go'
import {connectAutoComplete} from 'react-instantsearch-dom'
import Downshift from 'downshift'
import {navigate} from 'gatsby'

import {pathJoin, getLocalePath} from '../../utils/helpers'
import Results from './Results'

import './AutoComplete.scss'

function SearchInput(props) {
  return (
    <div className="search-box-wrapper">
      <input {...props} />
      <GoSearch className="search-icon" />
    </div>
  )
}

function AutoComplete({refine, release, setRelease}) {
  const [inputValue, setInputValue] = React.useState('')
  return (
    <Downshift
      inputValue={inputValue}
      onChange={section =>
        // go to selected doc
        navigate(pathJoin(getLocalePath(section.locale), section.slug))
      }
    >
      {downshiftProps => {
        const {getInputProps, isOpen} = downshiftProps
        return (
          <div className="auto-complete-wrapper">
            <SearchInput
              {...getInputProps({
                placeholder: 'Search all documentation',
                value: inputValue,
                onChange(e) {
                  setInputValue(e.target.value)
                  refine(e.target.value)
                },
              })}
            />
            {isOpen && (
              <Results
                downshiftProps={downshiftProps}
                release={release}
                setRelease={setRelease}
              />
            )}
          </div>
        )
      }}
    </Downshift>
  )
}

export default connectAutoComplete(AutoComplete)
